// @ts-nocheck
import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Book } from 'lucide-react';
import './NotFound.css';

/**
 * FIX-003 (refs AUD-002): Page 404 pour les routes inconnues.
 */
const NotFound = () => (
  <div className="not-found">
    <div className="not-found-content">
      <h1>404</h1>
      <p>Page non trouvée</p>
      <p className="not-found-hint">L’URL demandée n’existe pas ou a été déplacée.</p>
      <div className="not-found-actions">
        <Link to="/dashboard" className="not-found-link">
          <Home size={20} />
          <span>Tableau de bord</span>
        </Link>
        <Link to="/" className="not-found-link">
          <Book size={20} />
          <span>Bibliothèque</span>
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound;
